import {
    FETCH_JOBS_SUCCESS,
    FETCH_JOB_BY_ID_SUCCESS,

    JOBS_REQUEST_LOADING,
    JOBS_REQUEST_ERRORS,
    FETCH_JOBS_LOOKUP_SUCCESS,
    FETCH_HELPER_JOBS_LOOKUP_SUCCESS
} from "api/menu/master-files/job-maintenance/actions";

const initialState = {
    loading: false,
    errors: [],

    jobs: [],
    singleJob: {},

    jobsLookup: [],
    helperJobsLookup: [],
};

export default function(state = initialState, action) {
    switch (action.type) {
        case JOBS_REQUEST_LOADING:
            return {
                ...state,
                loading: true
            };
        case JOBS_REQUEST_ERRORS:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };
        case FETCH_JOBS_SUCCESS:
            return {
                ...state,
                loading: false,
                jobs: action.payload
            };
        case FETCH_JOB_BY_ID_SUCCESS:
            return {
                ...state,
                errors: [],
                singleJob: action.payload
            };
        case FETCH_JOBS_LOOKUP_SUCCESS:
            return {
                ...state,
                loading: false,
                jobsLookup: action.payload,
            };
        case FETCH_HELPER_JOBS_LOOKUP_SUCCESS:
            return {
                ...state,
                loading: false,
                helperJobsLookup: action.payload,
            };
        default:
            return state;
    }
}
